import { AnyAction } from 'redux'
import actionTypes from './actionTypes'
import { State } from './models'
import { mapToStateItems } from './helpers'

const initialState: State = {
  items: {},
  status: 'null'
}

export const reducer = (state: State = initialState, action: AnyAction): State => {
  switch (action.type) {
    case actionTypes.loaded: {
      const items = mapToStateItems(action.payload.movies)
      return {
        ...state,
        items,
        status: 'loaded'
      }
    }
    case actionTypes.loading: {
      return {
        ...state,
        status: 'loading'
      }
    }
    case actionTypes.loadingFailed: {
      return {
        ...state,
        status: 'failed'
      }
    }
    default: {
      return state
    }
  }
}
